import * as React from 'react';
import { useMount } from 'react-use';
import styled from 'styled-components';

import { useCountDownTimer } from '@doltech/ui/lib/hooks/useCountDownTimer';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { Button } from '@doltech/ui/lib/figma/ButtonV2/ButtonV2';
import { ModalHeader } from '@doltech/ui/lib/figma/Modal/ModalHeader/ModalHeader';
import { ModalHeaderContentSimpleText } from '@doltech/ui/lib/figma/Modal/ModalHeaderContentSimpleText/ModalHeaderContentSimpleText';
import { ModalFooter } from '@doltech/ui/lib/figma/Modal/ModalFooter/ModalFooter';
import { ModalFooterContentStyles } from '@doltech/ui/lib/figma/Modal/ModalFooterContentStyles/ModalFooterContentStyles';
import { ModalFooterContentButtonGroups } from '@doltech/ui/lib/figma/Modal/ModalFooterContentButtonGroups/ModalFooterContentButtonGroups';

const COUNT_DOWN_TIME = 5; // seconds

const Body = styled.div`
  text-align: center;
  padding: 8px 32px;
`;

const Container = styled.div`
  background-color: ${colorsV2.white100};
  border-radius: 12px;
`;

export interface ModalListeningTimeUpContentProps {
  nextSectionIndex?: number;
  onOk?: () => void;
  lastSection?: boolean;
}

export const ModalListeningTimeUpContent = (props: ModalListeningTimeUpContentProps) => {
  const { nextSectionIndex, lastSection = false, onOk } = props;

  const { countDownTimeInSeconds, startTimer, stopTimer } = useCountDownTimer(
    COUNT_DOWN_TIME,
    (timeInSeconds) => {
      if (timeInSeconds <= 0) {
        onOk();
      }
    },
    1000
  );

  useMount(() => {
    setTimeout(() => {
      startTimer();
    }, 1000);
  });

  if (lastSection) {
    return (
      <Container>
        <ModalHeader
          headerContent={
            <ModalHeaderContentSimpleText text="Hết thời gian làm bài" align="center" />
          }
        />
        <Body>
          <ResponsiveTypography.Paragraph variant="regular/14-20" color="black80">
            Đã hết thời gian làm bài section này, bạn sẽ được chuyển qua section review. Bạn sẽ được
            xem và sửa lại những câu chưa chắc
          </ResponsiveTypography.Paragraph>
        </Body>
        <ModalFooter
          footerContent={
            <ModalFooterContentStyles
              align="center"
              content={
                <ModalFooterContentButtonGroups>
                  <Button.Primary
                    onClick={() => {
                      stopTimer();
                      onOk();
                    }}
                  >
                    {`Review bài (${countDownTimeInSeconds}s)`}
                  </Button.Primary>
                </ModalFooterContentButtonGroups>
              }
            />
          }
        />
      </Container>
    );
  }

  return (
    <Container>
      <ModalHeader
        headerContent={<ModalHeaderContentSimpleText text="Hết thời gian làm bài" align="center" />}
      />
      <Body>
        <ResponsiveTypography.Paragraph variant="regular/14-20" color="black80">
          {`Đã hết thời gian làm bài section này, bạn sẽ được chuyển qua section ${
            nextSectionIndex + 1
          }.`}
        </ResponsiveTypography.Paragraph>
        <br />
        <ResponsiveTypography.Paragraph variant="regular/14-20" color="black80">
          Sau khi làm xong tất cả sections, tới section review, bạn sẽ được xem và sửa lại những câu
          chưa chắc
        </ResponsiveTypography.Paragraph>
      </Body>
      <ModalFooter
        footerContent={
          <ModalFooterContentStyles
            align="center"
            content={
              <ModalFooterContentButtonGroups>
                <Button.Primary
                  onClick={() => {
                    stopTimer();
                    onOk();
                  }}
                >
                  {`Next section (${countDownTimeInSeconds}s)`}
                </Button.Primary>
              </ModalFooterContentButtonGroups>
            }
          />
        }
      />
    </Container>
  );
};
